import Link from "next/link";
import { useRouter } from "next/router";

import { ILink } from "../../../../../utils/types";

import styles from "./GuideContentBody.module.scss";

interface HashLinkProps {
  href: string;
  content: string;
  style?: ILink["styles"];
}

function HashLink({ href, content, style }: HashLinkProps) {
  return (
    <Link
      href={href}
      className={styles.link}
      data-testid={href}
      style={{
        fontSize: "18px",
        ...style,
      }}
    >
      {content}
    </Link>
  );
}

interface NonHashLinkProps {
  href: string;
  content: string;
  style?: ILink["styles"];
}

function NonHashLink({ href, content, style }: NonHashLinkProps) {
  return (
    <a
      className={styles.link}
      data-testid={href}
      href={href}
      style={{
        fontSize: "18px",
        ...style,
      }}
    >
      {content}
    </a>
  );
}

interface LinkContentProps {
  field: ILink;
}

export default function LinkContent({ field }: LinkContentProps) {
  const hash = field.href.includes("#");
  const startsWithHash = field.href.startsWith("#");
  const startsWithHttp = field.href.startsWith("http");

  const router = useRouter();
  const { locale } = router;
  // 골프픽스 웹앱 내에서 다른 페이지로 이동할 때 field.href에 locale을 붙인다.
  const href =
    !startsWithHash && !startsWithHttp && locale
      ? `/${locale}${field.href}`
      : field.href;

  return hash ? (
    <HashLink href={href} content={field.content} style={field.styles} />
  ) : (
    <NonHashLink href={href} content={field.content} style={field.styles} />
  );
}
